/// <reference types="jqrangeslider" />
// Deklarace proměnných a funkcí, které nejsou součástí TS souborů
declare var lang: string;
declare var gTags: string;
declare var gCat: number;
declare var gPCat: number;
declare var gItem: number;
declare var gProducer: number;
declare var gsNameWeb: string;
declare var gAllArticles: boolean;
declare var _ajaxSearchBoxSelector: boolean;
declare var _boxSelectorParams: string;
declare var arrParamTabFunction: Array<string>;
declare var $h1: string;
declare var $title: string;
declare var $titleOrig: string;
declare var $urlOrig: string;
declare var $h1Orig: string;
declare var $metaDescOrig: string;
declare var features: Features;
declare var PRG_bLoadGtmFilter: boolean;
//declare function WordToUrl(input: string): string;
//declare function GetParam(input: string): string;
//declare function NonDiacritic(input: string): string;
declare function AjaxCatalogBeforeSend(): void;
declare function AjaxCatalogComplete(isOnlyPaging: boolean): void;
declare function AjaxAfter(isOnlyPaging: boolean): void;
//declare function catItemsHeight(): void;
//declare function IsSafariBrowser(): boolean;
//declare function toggleControlElement(): void;
declare function execScript(input: string): void;
declare function AddToFavoritiesFromLocalStorage(): void;
// Proměnné
var $iop = '';
var $sort = '';
var $page = 1;
var $pge = 0;
var $pnext = 0;
var $filter = '';
var $cat = 0;
var $item = 0;
var $producer = 0;
var $pcat = 0;
var $wsv = 0;
var $tags = '';
var $search = '';
var $searchAppend = '';
var $searchAction = '';
var $b2bFilter = '';
var $catsF = "";
var $attrF = "";
var $prodF = "";
var $paramF = '';
var $paramSeo = [];
var $urlSeo = "";
var $paramLastF = '';
var $vcp = '';
var $filterContractor = '';
var $filterCustomAttr = '';
var $filterHiddenAttr = '';
let $isExistAttrNeg = false;
var $filterProducer = '';
var $filterPrice = '';
var $filterAvail = '';
var $filterOthers = '';
var $eventIds = '';
var $backFromHistory = false;
var $changeP = 0;
var $parText = "";
var $countPar = 0;
var $type = "";
var bParWizard = false;
var bUseSort = false;
var sParentCatUrl = "";
var sNameParZnacka = "znacka";
var forceScrollDisabled = false;
var $nextPageOwner = null;
var $pagerElement = null;
var $nextPageSelectors = [".content-19", ".product-content", ".product-content-series", "#searchBlockCat", "#searchBlockFor", "#searchBlockArt", "#searchBlockFiles", "#searchBlockProd", "#tagsBlockProd", ".article-content", "#tagsBlockArt", "#searchBlockArt10", "#searchBlockArt20", "#searchBlockArt30"];
var $nextPageItemsSelectors = ["#Items", "#Items", "#Items", ".pListItems", ".pListItems", ".pListItems", "#SearchResultsFiles-sub", "#Items", "#Items", "#PublishArticles", "#PublishArticles", ".articleBox-Search", ".articleBox", ".articleBox"];
var filterSliders = [];
var $makeScroll = false;
var _previousFilterTab = "";
var _filterParamOpen = true;
var $floatingmenuheight = 0;
var $series = "";
var $seoParam: any = {};
var $pageSeries = 0;
var $urlPostfix = "";
var pattern = /\/p[0-9\-0-9]+/g;
var $filterYear = 0;
var $filterMonth = 0;


/** Nastaveni promennych */
function setVariables() {
    $search = getParmFromHash(window.location.search, 'search');
    $searchAction = getParmFromHash(window.location.search, 'searchaction');
    $tags = gTags;
    $cat = gCat;
    $pcat = gPCat;
    if (typeof gItem !== "undefined") { $item = gItem; }
    if (typeof gProducer !== "undefined") { $producer = gProducer; }
    $b2bFilter = ($('#B2BCtgr').length > 0 ? $('#B2BCtgr').val()?.toString() : '');

    $urlPostfix = GetTextDynamic("URL_POSTFIX_PRODUCT_CATEGORY");

    if ($urlPostfix == "#") {
        $urlPostfix = "/";
    }

    sNameParZnacka = GetTextDynamic("filter_producer_name_query_par");
}

/** Nabindování událostí na prvky filtrování, stránkování, řazení */
function bindForm() {
    setVariables();

    // pokud uživatel přijde na stránku s aktivním filtrem "sort", chceme ho zachovat, dokud ho sám nezmění (pak už to řeší jen AJAX)
    const sortParam = new URL(window.location.href).searchParams.get('sort');
    if (sortParam?.trim()) {
        bUseSort = true;
    }

    // samostatny control sort/ucSort
    $(document).on("submit", "#formSort", function (event) {
        event.preventDefault();
        // parametry
        PrepareParam();
        // staticke filtry (akcni, novinky...)
        PrepareStaticFiltr();
        // dodavatele
        PrepareContractorFiltr();
        // filtr uzivatelskych atributu
        PrepareCustomAttr();
        // filtr others
        PrepareOthers();
        //filtr vysledku hledani dle kategorii sestaveni ID do stringu
        PrepareCatsFilter();
        // vyhledavani
        if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }
        // trideni
        $sort = $('#hiddensort').val()?.toString();
        // cenovy slider
        // price-slider-apllyfiterparams = Zohlednit do cen parametry (modul 251)
        if (!$(".price-slider-apllyfiterparams").length) {
            $filterPrice = getPriceSliderValue();
        }
        // vyrobce
        PrepareProdFilter();
        // stranka
        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 1;
        bUseSort = true;

        if (features.SEOParam) { PrepareSeoUrl(); }

        loadAjaxContent(false);
    });

    $(document).on("click", ".sort-items-wrap a, .form-sort-link a", function (event) {
        event.preventDefault();
        if(!$(this).hasClass("active")) {
            // parametry
            PrepareParam();
            // staticke filtry (akcni, novinky...)
            PrepareStaticFiltr();
            // dodavatele
            PrepareContractorFiltr();
            // filtr uzivatelskych atributu
            PrepareCustomAttr();
            // filtr others
            PrepareOthers();
            //filtr vysledku hledani dle kategorii sestaveni ID do stringu
            PrepareCatsFilter();
            // vyhledavani
            if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }
            // trideni
            $sort = $(this).data("sort")?.toString();
            // cenovy slider
            // price-slider-apllyfiterparams = Zohlednit do cen parametry (modul 251)
            if (!$(".price-slider-apllyfiterparams").length) {
                $filterPrice = getPriceSliderValue();
            }
            // vyrobce
            PrepareProdFilter();
            // stranka
            $page = 1;
            $pge = 0;
            $pnext = 0;
            $changeP = 1;
            bUseSort = true;

            if (features.SEOParam) { PrepareSeoUrl(); }

            loadAjaxContent(false);
        }
    });

    $(document).on("submit", "#hiddensortBottom", function (e) {
        e.preventDefault();
        $sort = $('#hiddensortBottom').val()?.toString();
        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 1
        // cenovy slider
        $filterPrice = getPriceSliderValue();
        if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }
        bUseSort = true;

        loadAjaxContent(false);
    });
}

function BindCategoriesFilter() {
    $('.searchFilterCat-wrap').on('click', 'input', function (e) {
        PrepareCatsFilter();

        loadAjaxContent(false);
    });
}

function BindAttributesFilter() {
    $('.searchAttributes-wrap').on('click', 'input.ok', function (e) {
        PrepareAttrFilter();

        loadAjaxContent(false);
    });
}

function BindProducersFilter() {
    $('.searchProducers-wrap').on('click', 'input', function (e) {
        PrepareProdFilter();

        loadAjaxContent(false);
    });
}

function BindSeries() {
    if (features.CommoditySeries) {
        $('.switch-series').on('change', '.series-checkbox', function (e) {
            PrepareSeries();

            if ($(".switch-series .series-checkbox").is(":checked")) {
                $vcp = "list";
            }

            loadAjaxContent(false);
        });

        $series = $(".switch-series .series-checkbox").is(":checked") ? "1" : "0";
    }
}

//filtr vysledku hledani dle kategorii sestaveni ID do stringu
function PrepareCatsFilter() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $catsF = "";
    $(".searchFilterCat input:checkbox:checked").each(function () {
        if ($catsF.length > 0) { $catsF += "," }
        $catsF += $(this).val()?.toString().trim();
    });
}

//filtr vysledku hledani dle atributu sestaveni ID do stringu
function PrepareAttrFilter() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $attrF = "";
    $(".searchAttributes input.ok:checkbox:checked").each(function () {
        if ($attrF.length > 0) { $attrF += "," }
        $attrF += $(this).val()?.toString().trim();
    });
}

//filtr vysledku hledani dle atributu sestaveni ID do stringu
function PrepareProdFilter() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $prodF = "";
    $(".searchProducers input:checkbox:checked").each(function () {
        if ($prodF.length > 0) { $prodF += "," }
        $prodF += $(this).val()?.toString().trim();
    });
}

//produktove serie
function PrepareSeries() {
    $page = 1;
    $pge = 0;
    $pnext = 0;

    $series = $(".switch-series .series-checkbox").is(":checked") ? "1" : "0";
}

function PrepareParam() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $paramF = "";
    $countPar = 0;

    // Starsi verze rozdelena do modulu
    $("#formFiltersParam input:checkbox:checked, [class^=filters-tab-param] input:checkbox:checked").each(function () {
        $countPar += 1;
        if ($paramF.length > 0) { $paramF += "," }
        $paramF += WordToUrl($(this).val()?.toString().trim());
    });

    $paramF = $paramF.replace("/", "^");
}

function getLastParamSlider(slider) {
    var returnvalue = "";
    var p = 0;
    var v = '';

    $("#formFiltersParam input:checkbox:checked, [class^=filters-tab-param] input:checkbox:checked").each(function () {
        p += 1;
        v = WordToUrl($(this).val()?.toString().trim());
        if (v.indexOf('|') != -1)
            v = v.split('|')[0];

        if (v != slider)
            returnvalue = slider;
    });
    return returnvalue;
}

function clearSliderValues(sliderId) {
    var min = $('#hdn' + sliderId + 'min').val();
    var max = $('#hdn' + sliderId + 'max').val();

    var chck = $('#min' + sliderId).val()?.toString().split('|')[0];

    $('#min' + sliderId).val(chck + '|' + min).data("value", min);
    $('#max' + sliderId).val(chck + '|' + max).data("value", max);

    $('#min' + sliderId).prop('checked', false);
    $('#max' + sliderId).prop('checked', false);

    $paramLastF = '';
    $changeP = 0;

    PrepareParam();

    if (features.SEOParam) { PrepareSeoUrl(); }

    loadAjaxContent(false);
}

/** form statickych priznaku, akcni, novinky atd */
function PrepareStaticFiltr() {
    $page = 1;
    $filter = "";
    $("#frmFilter input:checkbox:checked, #tabFilterFlags input:checkbox:checked").each(function () {
        if ($filter.length > 0) { $filter += "," }
        $filter += $(this).attr('rel') + "-" + $(this).attr('id').replace("settFilterParam", "").replace("Chck", "").replace("settFilterOnStock", "0") + "|1";
    });

    if ($search !== "" || $tags !== "") { $searchAppend = "&filter=on&sProd=1"; }
}

/* form dodavatelu */
function PrepareContractorFiltr() {
    $page = 1;
    $filterContractor = "";
    $("#formfilterContractorGroup input:checkbox:checked").each(function () {
        if ($filterContractor.length > 0) { $filterContractor += "," }
        $filterContractor += $(this).attr('rel') + "|" + $(this).val();
    });
}

/** form uzivatelskych atributu */
function PrepareCustomAttr() {
    $page = 1;
    $filterCustomAttr = "";
    $isExistAttrNeg = false;

    $("#formFiltersCustomAttr input:checkbox:checked, #formFiltersCustomAttrNegation input:checkbox:checked").each(function () {
        if ($filterCustomAttr.length > 0) {
            $filterCustomAttr += ","
        }
        $filterCustomAttr += $(this).val();
        
        if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }

        if (typeof $(this).data('neg') !== 'undefined') {
            $isExistAttrNeg = true;
        }
    });
}

function PrepareHiddenAttr() {
    if ($("#notFilteredAttribute").length) {
        // filtry nastavene u kategorie typu doplnujici parametry
        $filterHiddenAttr = $("#notFilteredAttribute").val().toString();
    }
}

/** form others */
function PrepareOthers() {
    $filterOthers = "";
    if ($("#ddCalendarYear").length > 0) {
        $filterOthers = $("#ddCalendarYear").val()?.toString();
    }
}

function PrepareParamText() {
    $parText = "";

    // parametry
    if ($("#h1FromParam").length) {
        // toto je hodnota, ktera jde take ho H1, generuje se v DB
        $parText = $("#h1FromParam").val().toString();
    }
    else {
        $("#formFiltersParam input:checkbox:checked, #filters-tab input:checkbox:checked").each(function () {
            if ($parText.length > 0) { $parText += ", " }
            $parText += $(this).next().text();
        });
    }

    // staticke filtry
    $("#frmFilter input:checkbox:checked").each(function () {
        if ($parText.length > 0) { $parText += "," }
        $parText += $(this).parent().find("a").text().toLowerCase();
    });

    if ($parText.length > 0) { $parText = " - " + $parText; }
    return $parText;
}

var _producerClose = true;

function prepareLinks() {
    $paramF = GetParam("par");

    $('a', '#formSort').each(function () {
        var $cl = $(this).attr('onclick');
        if ($cl != null) {
            $(this).attr('onclick', $cl.replace("document.getElementById('formSort')", "$('#formSort')"));
        }
    });

    // ajax dater v katalogu
    initAjaxDater();

    //checkbox
    $("#formFiltersParam input[name=par], #filters-tab div[class^=filters-tab-param] input[name=par]").unbind('click').click(function () {
        if (bParWizard) { ParamControlWizard(); }
        $countPar = 0;
        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 0;
        $paramF = "";
        $paramLastF = "";

        // Pokud jsou nejaky slidery tak je dame checked at toho muzem vybrat vice
        $('input[name=par].paramUsed').prop('checked', true);

        $("#formFiltersParam input:checkbox:checked, [class^=filters-tab-param] input:checkbox:checked").each(function () {
            $page = 1;
            $pge = 0;
            $pnext = 0;
            if ($paramF.length > 0) { $paramF += ","; }
            $paramF += WordToUrl($(this).val()?.toString().trim());
            $countPar += 1;
        });

        $paramLastF = WordToUrl($(this).val()?.toString().split("|")[0]);

        if (sParentCatUrl.length > 0) {
            window.location.href = sParentCatUrl + "?par=" + $paramF;
            return;
        }

        if ($(this).attr('class') == "url") {
            var query = $paramF.length > 0 ? "?par=" + $paramF : "";
            window.location.href = "/" + WordToUrl($(this).val()?.toString().split("|")[1]) + "/" + query;
        }

        if (!$(this).hasClass("NextPageBtn") && !forceScrollDisabled && !$('#filters-tab > .resp-tabs-container > h2').hasClass("resp-tab-active")) {
            $makeScroll = ($('.NavBar .p-number, .NavBar .p-button-number').parents('.pos-2').length > 0);
        }

        if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }

        if (features.SEOParam) { PrepareSeoUrl(); }

        loadAjaxContent(false);
    });

    //select box
    $('#ddCalendarYear').unbind('change').bind('change', function () {
        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 0;
        PrepareOthers();

        loadAjaxContent(false);
    });

    $("#formFiltersParam select").unbind('change').bind('change', function () {
        $countPar = 0;
        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 0;
        $paramF = "";
        $paramLastF = "";
        var sel = false;

        $paramLastF = WordToUrl($(this).val()?.toString().split("|")[0]);

        $("#formFiltersParam select").each(function () {
            if (sel) { $(this).find("option:selected").removeAttr('selected'); }
            if (WordToUrl($(this).attr("name").toLowerCase()) == $paramLastF.toLowerCase()) { sel = true; }
        });

        if ($(this).attr('class') == "url") {
            var query = $paramF.length > 0 ? "?par=" + $paramF : "";
            window.location.href = "/" + WordToUrl($(this).val()?.toString().split("|")[1]) + "/" + query;
        }

        $("#formFiltersParam option:selected").each(function () {
            $page = 1;
            $pge = 0;
            $pnext = 0;

            if ($(this).val()?.toString().trim().length > 0) {
                if ($paramF.length > 0) { $paramF += ","; }
                $paramF += WordToUrl($(this).val()?.toString().trim());
                $countPar += 1;
            }
        });

        if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }

        loadAjaxContent(false);
    });

    // razeni dole
    $('a', '#formSortBottom').each(function () {
        var $cl = $(this).attr('onclick');
        if ($cl != null) {
            $(this).attr('onclick', $cl.replace("document.getElementById('formSortBottom')", "$('#formSortBottom')"));
        }
    });

    // strankovani
    $('a', '.pager-wrap').unbind('click').click(function (e) {
        e.preventDefault();
        $changeP = 1;
        var href = $(this).attr('href');
        $pagerElement = $(this);

        // staticke filtry (akcni, novinky...)
        PrepareStaticFiltr();

        if (href.indexOf('?search=') == -1 && href.indexOf('&search=') == -1) {
            var re1 = /\/p(\d+)\//g;
            href = href.replace(re1, "&page=$1&");
        }

        if ($(this).hasClass('NextPageBtn')) {
            $nextPageOwner = $(this);
            // dalsi stranka
            $pnext = Number($(this).data("pnext"));
            $pge = Number($(this).data("page"));
            $page = Number($(this).data("page"));
            $type = $(this).data("type");

            if ($type != "") // JB aby se parametry načetly jen u produktů 
                $filter = "";

            if ($eventIds === "" && getParmFromHash(href, "ids") !== "") {
                $eventIds = getParmFromHash(href, "ids");
            }

            if (features.SEOParam) { PrepareSeoUrl(); }

            // pridano kvuli nefunkcnosti tlacka dalsi u kategorie typ doplnkove parametry - prz
            if ($paramF === "") {
                $paramF = GetParam("par");
                if ($paramF == "") {
                    $paramF = decodeURIComponent(href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent("par").replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
                }
            }
        }
        else {
            $nextPageOwner = null;
            
            $type = $(this).data("type");
            $page = Number($(this).data("page"));

            if ($type != "") // JB aby se parametry načetly jen u produktů 
                $filter = "";

            if ($page == 0) $page = 1;
            $pge = 0;
            $pnext = 0;

            if ($eventIds === "" && getParmFromHash(href, "ids") !== "") {
                $eventIds = getParmFromHash(href, "ids");
            }

            if (features.SEOParam) {
                PrepareSeoUrl();
            }

            if ($paramF === "") {
                // pridano kvuli nefunkcnosti tlacka dalsi u kategorie typ doplnkove parametry - prz
                $paramF = decodeURIComponent(href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent("par").replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
            }

            $makeScroll = ($('.NavBar .p-number, .NavBar .p-button-number').parents('.pos-2,.pos-4').length > 0);
        }

        if ($search != '' || $tags != '') {
            if (href.indexOf('&sCat=1') != -1) { $searchAppend = '&filter=on&sCat=1'; }
            else if (href.indexOf('&sArt=30') != -1) { $searchAppend = '&filter=on&sArt=30'; }
            else if (href.indexOf('&sArt=20') != -1) { $searchAppend = '&filter=on&sArt=20'; }
            else if (href.indexOf('&sArt=10') != -1) { $searchAppend = '&filter=on&sArt=10'; }
            else if (href.indexOf('&sArt=1') != -1) { $searchAppend = '&filter=on&sArt=1'; }
            else if (href.indexOf('&sArt=2') != -1) { $searchAppend = '&filter=on&sArt=2'; }
            else if (href.indexOf('&sFor=1') != -1) { $searchAppend = '&filter=on&sFor=1'; }
            else if (href.indexOf('&sFile=1') != -1) { $searchAppend = '&filter=on&sFile=1'; }
            else if (href.indexOf('&sSeries=1') != -1) { $searchAppend = '&filter=on&sSeries=1';  }
            else { $searchAppend = '&filter=on&sProd=1';  }
            if (href.indexOf('&spcat=') !== -1) { $searchAppend += '&spcat=' + getParmFromUrlHash(href, "spcat"); }
        }

        // cenovy posuvnik
        $filterPrice = getPriceSliderValue();
        $sort = SortValGet();
        
        loadAjaxContent(false);
    });

    // pocet produktu na strance
    $('select[name="iop"]', '.iop-wrap').unbind('change').removeAttr("onchange").bind('change', function (event) {
        event.preventDefault();
        $changeP = 1;
        if ($search != '' || $tags != '') {
            $searchAppend = '&filter=on&sProd=1';
        }
        if ($("#vcp").length > 0) {
            $vcp = $("#vcp").val()?.toString();
        }

        $page = 1;
        $pge = 0;
        $pnext = 0;
        $iop = $(this).val()?.toString();
        $sort = SortValGet();

        loadAjaxContent(false);
    });

    // razeni, pokud je selectbox
    $('select[name="sort"]', '.sort-wrap').unbind('change').removeAttr("onchange").bind('change', function (event) {
        event.preventDefault();

        if ($search != '' || $tags != '') {
            $searchAppend = '&filter=on&sProd=1';
        }

        $page = 1;
        $pge = 0;
        $pnext = 0;
        $changeP = 1;
        $sort = $(this).find("option:selected").val()?.toString();
        bUseSort = true;

        loadAjaxContent(false);
    });

    $('.FilterMobile .OpenFilter').unbind('click').click(function (e) {
        $('#formFiltersParam').addClass("FilterOpen");
        $("#filterStatic").addClass("FilterOpen");
        return false;
    });

    $('.FilterMobile .CloseFilter').unbind('click').click(function (e) {
        $('#formFiltersParam').removeClass("FilterOpen");
        $("#filterStatic").removeClass("FilterOpen");
        return false;
    });

    // typ zobrazeni v katalogu, dlazdice, seznamove zobrazeni
    $('.swith-views a').unbind('click').click(function (event) {
        event.preventDefault();
        if ($search != '' || $tags != '') {
            $searchAppend = '&filter=on&sProd=1';
        }

        $page = 1;
        $pge = 0;
        $pnext = 0;
        $iop = '';
        $changeP = 1;
        $sort = SortValGet();
        $vcp = $(this).attr("rel");

        loadAjaxContent(false);
    });

    // šířka layoutu v katalogu
    if ($('.wide-selector').length) {
        var $wsa = $('.wide-selector a.wsa');
        var $wsb = $('.wide-selector');
        var $wsm = $('.wide-selector .wide-selector-menu');
        var $wsl = $('.wide-selector .wide-selector-menu .ws');
        var $wss = $('.wide-selector input[name="catwidth"]');

        $wsa.unbind('click').click(function (event) {
            event.preventDefault();
            $wsb.toggleClass('collapsed');
            $wsm.toggle();
        });

        $wsl.unbind('click').click(function (event) {
            event.preventDefault();
            $wss.val($(this).data('ws'));
            $wsv = parseInt($(this).data('ws'));
            $('body').removeClass('catalog-extend catalog-wide').addClass($wsv == 1 ? "catalog-extend" : ($wsv == 2 ? "catalog-wide" : ""));
            $changeP = 1;

            loadAjaxContent(false);
        });
    }

    // filtry staticke (akcni, novinky...)
    if ($('#frmFilter').length) {
        $('#frmFilter input:checkbox, #tabFilterFlags input:checkbox').unbind('click').click(function (event) {
            PrepareStaticFiltr();
            $changeP = 0;
            $type = "";
            loadAjaxContent(false);
        });
    }

    // filtry na dodavatele
    if ($('#formfilterContractorGroup').length) {
        $('#formfilterContractorGroup input:checkbox').unbind('click').click(function (event) {
            PrepareContractorFiltr();
            $changeP = 0;

            loadAjaxContent(false);
        });
    }

    // filtry uzivatelskych atributu
    if ($('#formFiltersCustomAttr').length || $('#formFiltersCustomAttrNegation').length) {
        $('#formFiltersCustomAttr input:checkbox, #formFiltersCustomAttrNegation input:checkbox').unbind('click').click(function (event) {
            event.preventDefault();
            PrepareCustomAttr();
            $changeP = 0;

            if (features.SEOParam) { PrepareSeoUrl(); }

            loadAjaxContent(false);
        });

        $('#formFiltersCustomAttr .linkCA, #formFiltersCustomAttrNegation .linkCA').unbind('click').click(function (event) {
            event.preventDefault();

            $page = 1;
            $changeP = 0;
            
            if ($(this).is("[id]")) {
                var id = $(this).attr('id').replace('linkCA', 'chckCA');

                if ($('#' + id).is(':checked')) {
                    $('#' + id).removeAttr('checked');
                }
                else {
                    $('#' + id).attr('checked', 'checked').prop('checked', 'checked');
                }

                $('input[id!="' + id + '"]').removeAttr('checked');
            }

            $(this).toggleClass('checked');
            PrepareCustomAttr();

            loadAjaxContent(false);
        });
    }

    if ($('#formFilters').length || $('.filters-tab-producer').length) {
        $('#formFilters input:checkbox, .filters-tab-producer input:checkbox').unbind('click').click(function () {
            // filtr na vyrobce
            ProducerFilter();
            $changeP = 0;

            loadAjaxContent(false);
        });
    }

    if ($('#FiltersAvailability').length || $('.filters-tab-avail').length) {
        $('#FiltersAvailability input:checkbox, .filters-tab-avail input:checkbox').unbind('click').click(function () {
            // Filtr na dostupnost
            AvailabilityFilter();
            $changeP = 0;

            loadAjaxContent(false);
        });
    }

    $('#hlProducerShowAll').unbind('click').click(function () {
        $("#formFilters div").each(function (index) {
            if ($(this).attr("class") == "") {
                $(this).addClass("hide");

                _producerClose = true;
            }
            else if ($(this).attr("class") == "show") {
            } else {
                $(this).removeClass("hide");
                _producerClose = false;
            }
        });

        if (_producerClose) {
            $(this).text("Zobrazit vše");
        }
        else {
            $(this).text("Skrýt");
        }
    })

    if (bParWizard) { ParamControlWizard(); }

    $(".labelRemoveAll").unbind("click").click(function () {
        RemoveAllFilter(false);
    });

    $(".labelAddNext").unbind("click").click(function () {
        var object = $('.filters-tab-envelope');
        var display = object.css("display");

        if (display == "none") {
            object.fadeIn('fast');
            _filterParamOpen = true;
            $("button[name=showFiltersData]").addClass("active");
        }

        openFilters();
        FloatingmenuheightGet();

        $('html, body').animate({ scrollTop: $(".filters-tab-envelope").offset().top - 20 - $floatingmenuheight }, 500);
    });
}

function ParamControlWizard() {
    var c = 0;
    var ch = false;
    $("#formFiltersParam .filterBody").children("div").each(function () {
        c += 1;
        var ch_Sub = ch;
        ch = true;
        var $o = $(this);
        $(this).find(":checkbox").each(function () {
            if (ch_Sub) { $(this).attr("disabled", "disabled"); $(this).removeAttr("checked"); $o.addClass("whide"); }
            if ($(this).prop("checked")) { ch = false; }
        });
        $(this).find("select").each(function () {
            if (ch_Sub) { $(this).attr("disabled", "disabled"); $(this).find("option:selected").removeAttr('selected'); $o.addClass("whide"); }
            if (typeof $(this).find("option:selected").val() != 'undefined') {
                if ($(this).find("option:selected").val()?.toString().length > 0) { ch = false; }
            }
        });
    });
}

function InitProducerFilter() {
    $filterProducer = "";
    $('input[name=' + sNameParZnacka + ']:checkbox:checked').each(function (index) {
        if ($filterProducer.length > 0) { $filterProducer += "," }
        $filterProducer += $(this).val();
    });
}

function ProducerFilter() {
    InitProducerFilter();
    $page = 1;
}

function InitAvailabilityFilter() {
    $('#FiltersAvailability').on('click', '#FiltersAvailabilityShowHide', function (e) {
        e.preventDefault();
        $('#FiltersAvailability .hide').toggle();
    });

    $filterAvail = "";
    $('input[name=' + queryStringAvail + ']:checkbox:checked').each(function (index) {
        if ($filterAvail.length > 0) { $filterAvail += "," }
        $filterAvail += $(this).val();
    });
}

function AvailabilityFilter() {
    InitAvailabilityFilter();
    $page = 1;
}

function unbind() {
    $('#ddCalendarYear').unbind('change');
    $('select[name="iop"]', '.iop-wrap').unbind('change');
    $('.swith-views a').unbind('click');
    $('#frmFilter input:checkbox').unbind('click');
    $('#formfilterContractorGroup input:checkbox').unbind('click');
    $('#formFiltersCustomAttr input:checkbox').unbind('click');
    $('#formFiltersCustomAttrNegation input:checkbox').unbind('click');
    $('#formFiltersCustomAttr .linkCA').unbind('click');
    $('#formFiltersCustomAttrNegation .linkCA').unbind('click');
    $('a', '.pager-wrap').unbind('click');

    if ($(window).width() < 680 && $nextPageOwner == null) {
        $(".CloseFilter").click();

        $('.product-content', '.article-content').each(function (index) {
            if ($(this).length > 0) {
                $('html, body').animate({ scrollTop: $(this).offset().top }, 500);
            }
        });
    }
}

function OnChangePriceSlider(frmUrl) {
    var $filterPrice = getPriceSliderValue();

    if (frmUrl != '') {
        $('#formPrice').attr('action', frmUrl);
    }
    $('input', '#formPrice').val($filterPrice);
    $('#formPrice').submit();
}

function getPriceSliderValue() {
    var filterPrice = '';
    if ($('#minPriceFilter').val() != $('#fromPriceFilter').val() || $('#maxPriceFilter').val() != $('#toPriceFilter').val()) {
        filterPrice = $('#fromPriceFilter').val() + "/" + $('#toPriceFilter').val();
    }
    return filterPrice;
}

function PreparePrice() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $filterPrice = getPriceSliderValue();
    if ($search != '' || $tags != '') { $searchAppend = '&filter=on&sProd=1'; }
    if (features.SEOParam) { PrepareSeoUrl(); }

    loadAjaxContent(false);
}

function getSerializedString() {
    var _search = $search.replace(/\%25+/g, ' ');
    _search = decodeURI(NonDiacritic(_search)).replace(/\s+/g, '+');

    let $fattrBuilder = '';
    if ($filterCustomAttr) {
        $fattrBuilder = $filterCustomAttr;
    }
    if ($attrF) {
        $fattrBuilder += $fattrBuilder ? ',' + $attrF : $attrF;
    }
    if ($filterHiddenAttr) {
        $fattrBuilder += $fattrBuilder ? ',' + $filterHiddenAttr : $filterHiddenAttr;
    }
    
    var sSerialize = "page=" + $page +
        ($pge > 0 ? "&pge=" + $pge : '') +
        ($search == '' ? '' : "&search=" + _search + $searchAppend + ($searchAction != "" ? "&searchaction=" + $searchAction : "")) +
        ($pnext > 0 ? "&pnext=" + $pnext : '') +
        ($tags == '' ? '' : "&tags=" + $tags + $searchAppend) +
        ($cat * 1 > 0 ? "&cat=" + $cat : '') +  
        ($item != 0 ? "&item=" + $item : "") +
        ($producer > 0 ? "&producer=" + $producer : "") +
        ($pcat * 1 > 0 ? "&pcat=" + $pcat : '') +
        ($iop == '' ? '' : '&iop=' + $iop) +
        ($vcp == '' ? '' : '&vcp=' + $vcp) +
        ($b2bFilter == '' ? '' : '&B2BCtgr=' + $b2bFilter) +
        ($paramF == '' ? '' : '&par=' + $paramF) +
        //last vlozim pouze pokud je vice nez jeden parametr
        ($paramLastF == '' || $countPar < 2 ? '' : '&last=' + $paramLastF) +
        ($filter == '' ? '' : "&filter=" + $filter) +
        ($filterContractor == '' ? '' : '&fcon=' + $filterContractor) +
        ($fattrBuilder == '' ? '' : '&fattr=' + $fattrBuilder) +
        ($isExistAttrNeg == true ? '&fattrneg=1' : '') +
        ($filterProducer == '' ? '' : '&' + sNameParZnacka + '=' + $filterProducer.replace("@", "[at]")) +
        ($filterOthers == '' ? '' : '&CalendarYear=' + $filterOthers) +
        ($filterYear == 0 ? '' : '&year=' + $filterYear) +
        ($filterMonth == 0 ? '' : '&month=' + $filterMonth) +
        ($filterPrice == '' ? '' : '&fPrice=' + $filterPrice) +
        ($filterAvail == '' ? '' : '&' + queryStringAvail + '=' + $filterAvail) +
        ($catsF == '' ? '' : '&fCats=' + $catsF) +
        ($prodF == '' ? '' : '&fProd=' + $prodF) +
        (bUseSort ? "&sort=" + $sort : '') +
        ($wsv > 0 ? '&catwidth=' + $wsv : '') +
        (gAllArticles ? "&aa=1" : "") +
        ($eventIds == '' || $eventIds == '&ids=' ? '' : '&ids=' + $eventIds.substring(0, $eventIds.length - 1)) +
        ($('.box-selector').length > 0 && _ajaxSearchBoxSelector && _boxSelectorParams.length > 0 ? "&boxparams=" + _boxSelectorParams : "") +
        ($series == '' || $search != '' ? '' : '&series=' + $series);
    
    // odstrani duplicity z url
    sSerialize = sSerialize.replace(/.*\?/g, '').split('&').filter((e, i, a) => a.indexOf(e) === i).join('&');
    
    return sSerialize;
}

function loadAjaxContent(processOnlyFilterPart) {
    if (processOnlyFilterPart != true) {
        processOnlyFilterPart = false;
    }

    var sSerialize = getSerializedString();
    var $parentContent;

    $.ajax({
        type: "GET",
        cache: false,
        url: "/ajax/commodityContent.aspx",
        data: sSerialize + (lang.length > 0 ? "&lang=" + lang : "") + (processOnlyFilterPart ? "&paramFilterInit=1&ms=" + $('.ajax-filter-init').data('ms') : "") + ($changeP === 1 ? "&paging=1" : "") + ($nextPageOwner != null ? "&nextPage=1" : ""),
        error: function (data) {
            ;
        },
        beforeSend: function () {
            if (!processOnlyFilterPart) preloader(true);
            if (typeof AjaxCatalogBeforeSend == 'function') { AjaxCatalogBeforeSend(); }
        },
        complete: function () {
            if (typeof AddToFavoritiesFromLocalStorage == "function") { AddToFavoritiesFromLocalStorage(); }

            if (!processOnlyFilterPart) {
                if (typeof ($("input.spinbutton").stepper) == "function") {
                    $("input.spinbutton").stepper();
                }
                if (typeof AjaxAfter == 'function') {
                    AjaxAfter($changeP == 1);
                }
            }

            // Tuto funkci nadefinovat site.js, tj. JS z Adminu, pokud je potřeba spouštět nějaké JS po ajaxovém stránkování
            if (typeof AjaxCatalogComplete == 'function') {
                AjaxCatalogComplete($changeP == 1);
            }

            if (typeof enhancedEcommerceEvent == "function") {
                enhancedEcommerceEvent();
            }

            if (typeof adviceJetInitCatalog === "function") {
                adviceJetInitCatalog();
            }

            if (!processOnlyFilterPart) {
                ProductPreview();
                availability();
                // Schoavani v ucFitlersParam
                if (typeof (arrParamTabFunction) == 'object') {
                    var evalJs = "";
                    // ReSharper disable once TsResolvedFromInaccessibleModule
                    for (var i = 0; i < arrParamTabFunction.length; i++) {
                        evalJs += arrParamTabFunction[i];
                    }
                    // Seznam fci musime spustit aby se to nabindovalo. Jkao ale bych brecel takova kravina kterou vyuzije a oceni 1 clovek :DD
                    eval(evalJs);
                }
            }

            if (IsSafariBrowser()) {
                setTimeout(prepareLinks, 300);
            } else {
                prepareLinks();
            }

            $changeP = 0;
            $nextPageOwner = null;
            $backFromHistory = false;
        },
        success: function (data) {
            var aData = data.split('#end#');

            if ($nextPageOwner != null) {
                // tlacitko "zobrazit dalsi produkty"
                $.each(aData, function (index, value) {
                    if ($.inArray(value.split('#begin#')[0].split(':')[0], $nextPageSelectors) == -1) {
                        $(value.split('#begin#')[0]).empty();
                    }
                });

                $.each(aData, function (index: number, value) {
                    var selector = value.split('#begin#')[0];
                    index = $.inArray(selector.split(':')[0], $nextPageSelectors);

                    if (index >= 0) {
                        var sDataHtml = $(value.split('#begin#')[1]).filter($nextPageItemsSelectors[index]).html();
                        if (sDataHtml == undefined) { sDataHtml = $(value.split('#begin#')[1]).find($nextPageItemsSelectors[index]).html(); }

                        // muze se stat, ze na strance mame vice univerzalnich vypisu
                        if ($pagerElement != null && $(selector).length > 1) {
                            selector = "." + $pagerElement.closest(selector).attr("class").split(" ").join(".");
                            $parentContent = $pagerElement.closest(".product-content, .article-content");
                        }
                        else if ($(selector).length > 1) {
                            // vicekrat muze byt pouze vypis 302
                            // ten ktery nas zajima by mel mit pager
                            $(selector).each(function (i, obj) {
                                if ($(this).find(".NavBar").length) {
                                    selector = "." + $(this).attr("class").split(" ").join(".");
                                }

                            });
                        }

                        $(selector + " " + $nextPageItemsSelectors[index]).append(sDataHtml);
                        $(selector + " " + $nextPageItemsSelectors[index]).find(".spacer:first").remove();

                        sDataHtml = $(value.split('#begin#')[1]).filter(".NavBar").first().html();
                        if (sDataHtml == undefined) { sDataHtml = $(value.split('#begin#')[1]).find(".NavBar").first().html(); }
                        $(".NavBar.pos-1").html(sDataHtml);

                        sDataHtml = $(value.split('#begin#')[1]).filter(".NavBar").last().html();
                        if (sDataHtml == undefined) { sDataHtml = $(value.split('#begin#')[1]).find(".NavBar").last().html(); }
                        $nextPageOwner.closest(".NavBar").html(sDataHtml);

                        // spusteni javasriptu v html
                        parseScript(data);
                    }
                    else {
                        $(selector).append(value.split('#begin#')[1]);
                    }
                });

                if (!$backFromHistory) {
                    var url = "";

                    if (features.SEOParam && $cat > 0) {
                        url = getClearUrl3("");
                    }
                    else {
                        url = getClearUrl3(getSerializedString());
                    }
                    window.history.pushState(sSerialize, document.title, url);
                }
            }
            else {
                // klasicke strankovani produktu
                $.each(aData, function (index, value) {
                    var selector = value.split('#begin#')[0];
                    // muze se stat, ze na strance mame vice univerzalnich vypisu
                    if ($pagerElement != null && $(selector).length > 1) {
                        selector = "." + $pagerElement.closest(selector).attr("class").split(" ").join(".");
                        $parentContent = $pagerElement.closest(".product-content, .article-content");
                    }
                    else if ($(selector).length > 1) {
                        // vicekrat muze byt pouze vypis 302
                        // ten ktery nas zajima by mel mit pager
                        $(selector).each(function (i, obj) {
                            if ($(this).find(".NavBar").length) {
                                selector = "." + $(this).attr("class").split(" ").join(".");
                            }
                        });
                    }
                    else if ($pagerElement != null && $(".search-content").length > 0 && $(".resp-tabs-list").length == 0 && $(selector).closest(".search-content").length) {
                        // nejsou zalozky ve vyhledavani
                        var c = "#" + $pagerElement.closest(".search-content").attr("id");
                        $parentContent = $(c);
                    }
                    
                    $(selector).html(value.split('#begin#')[1]);
                });

                if (features.SEOParam && $search == "") {
                    IsSafariBrowser() ? InnerSeoH1() : setTimeout(InnerSeoH1, 100);
                }
                else if (IsSafariBrowser()) {
                    $backFromHistory = false;
                    setTimeout(InnerH1, 100);
                }
                else {
                    InnerH1();
                }

                if (!$backFromHistory) {
                    var url = "";

                    if (features.SEOParam && $cat > 0) {
                        url = getClearUrl3("");
                    }
                    else {
                        url = getClearUrl3(getSerializedString());
                    }

                    if (bUseSort && $sort == '' && getParmFromHash(url, "sort") == "") {
                        url = url.replace('?sort=', '').replace('&sort=', '');
                    }

                    var title = GetTitle();
                    if (title == "empty" || title == "") title = document.title;

                    history.pushState(sSerialize, title, url);
                }
            }

            preloader(false);

            unbind();
            toggleControlElement();
            ButtonBuy();
            FloatingmenuheightGet();

            if (!processOnlyFilterPart && $makeScroll && $parentContent != null && $parentContent.length > 0) {
                // muze se stat, ze na strance mame vice univerzalnich vypisu, ale zname pagera a tim padem i parenta
                $('html, body').animate({ scrollTop: $parentContent.offset().top - $floatingmenuheight }, 200);
                $makeScroll = false;
            }

            if (!processOnlyFilterPart && $makeScroll) {
                $('.product-content, .article-content').each(function (index) {
                    if ($makeScroll && $(".has-scroll-bar").length) {
                        // muze se stat, ze mam nastaven na katalog scollbar
                        $(".has-scroll-bar").animate({ scrollTop: 0 }, 200);
                        $makeScroll = false;
                    }
                    else if ($makeScroll && $("#formSort").length) {
                        $('html, body').animate({ scrollTop: $("#formSort").offset().top - $floatingmenuheight }, 200);
                        $makeScroll = false;
                    }
                    else if ($makeScroll && $("#formNavBar1").length) {
                        $('html, body').animate({ scrollTop: $("#formNavBar1").offset().top - $floatingmenuheight }, 200);
                        $makeScroll = false;
                    }
                    else if ($makeScroll && $(this).closest(".block-book-mark").length && !$("body").hasClass("is-mobile")) {
                        // zalozky, vyhledavani, pro desktop, posuneme na zalozky
                        $('html, body').animate({ scrollTop: $(this).closest(".block-book-mark").find(".resp-tabs-list").offset().top - $floatingmenuheight }, 200);
                        $makeScroll = false;
                    }
                    else if ($makeScroll && $(this).closest(".block-book-mark").length && $("body").hasClass("is-mobile")) {
                        // zalozky, vyhledavani, pro mobily, posuneme na obsah
                        $('html, body').animate({ scrollTop: $(this).closest(".resp-tabs-container").offset().top - $floatingmenuheight }, 200);
                        $makeScroll = false;
                    }
                    else if ($makeScroll && $(this).length > 0) {
                        $('html, body').animate({ scrollTop: $(this).offset().top - 40 - $floatingmenuheight }, 200);
                        $makeScroll = false;
                    }
                });
            }

            if ($pagerElement != null) {
                $pagerElement = null;
            }

            $makeScroll = false;
        }
    });
}

function parseScript(_source) {
    var source = _source;
    var scripts = new Array();

    while (source.toLowerCase().indexOf("<script") > -1 || source.toLowerCase().indexOf("</script") > -1) {
        var s = source.toLowerCase().indexOf("<script");
        var s_e = source.indexOf(">", s);
        var e = source.toLowerCase().indexOf("</script", s);
        var e_e = source.indexOf(">", e);

        var subsSourceJsonLd = source.substring(s, s_e);

        if (subsSourceJsonLd.toLowerCase().indexOf('data-onceindom="true"') !== -1) {
            // scripty s oznacenim OnceInDom se pousti automaticky po pridani do dom, neni treba poustet znovu 
            source = source.substring(0, s) + source.substring(e_e + 1);
            continue;
        }

        // Json LD nevkladame
        if (subsSourceJsonLd.indexOf("application/ld+json") === -1) {
            scripts.push(source.substring(s_e + 1, e));
        } else {
            // Pro tlacko "dalsich X" je potreba json vlozit do page
            if ($nextPageOwner != null) {
                $("body").append(subsSourceJsonLd + ">" + source.substring(s_e + 1, e) + "</script>");
            }
        }
        source = source.substring(0, s) + source.substring(e_e + 1);
    }

    for (var i = 0; i < scripts.length; i++) {
        try {
            if (scripts[i] != '') {
                try {
                    execScript(scripts[i]);
                }
                catch (ex) {
                    eval(scripts[i]);
                }
            }
        }
        catch (e) {
            if (e instanceof SyntaxError) console.log(e.message + ' - ' + scripts[i]);
        }
    }
}

function InnerSeoH1() {
    var $sufix = "";
    var $perex = "";
    var $h1 = $h1Orig;
    var $title = $titleOrig;
    var $metaDesc = "";
    var $sWeb = gsNameWeb.length > 0 && gsNameWeb != "empty" ? " | " + gsNameWeb : "";
    var $sortSeo = $sort;
    if (!$sortSeo.length) { $sortSeo = $("#formSort a.active").data("sort"); }
    var sortAppend = GetTextDynamic("head_line_sort_" + $sortSeo);

    if (typeof $seoParam !== 'undefined' && $seoParam != null && $seoParam && $seoParam.length) {
        ////////////////////////////////////////////
        // H1
        $.each($seoParam, function (i, item) {
            if (item.sH1Type == "replace" && item.sH1.length) {
                $h1 = item.sH1;
            }
            else if (item.sH1Type == "sufix" && item.sH1.length) {
                // pridat za
                $sufix = $sufix + (item.sH1.substring(0, 1) == "," ? "" : " ") + item.sH1;
            }
            else if (item.sH1Type == "perex" && item.sH1.length) {
                // pridat pred
                $perex = $perex + " " + item.sH1;
            }
        });

        // pred H1
        if ($perex.length) { $perex = $perex.trim() + " "; }
        // za H1
        if ($sufix.length) { $sufix = ($sufix.substring(0, 1) == "," ? "" : " ") + $sufix.trim(); }

        $h1 = $perex + $h1 + $sufix;
        $h1 = $h1.trim();

        if (sortAppend && sortAppend.length) {
            $h1 += sortAppend;
        }

        if ($h1 && $h1.length) {
            $h1 = $h1[0].toUpperCase() + $h1.slice(1).toLowerCase();
            $("h1:first").html($h1);
        }

        $sufix = "";
        $perex = "";

        ////////////////////////////////////////////
        // title
        $.each($seoParam, function (i, item) {
            if (item.sTitleType == "replace" && item.sTitle.length) {
                $title = item.sTitle;
            }
            else if (item.sTitleType == "sufix" && item.sTitle.length) {
                // pridat za
                $sufix = $sufix + (item.sTitle.substring(0, 1) == "," ? "" : " ") + item.sTitle;
            }
            else if (item.sTitleType == "perex" && item.sTitle.length) {
                // pridat pred
                $perex = $perex + " " + item.sTitle;
            }
        });

        // pred title
        if ($perex.length) { $perex = $perex.trim() + " "; }
        // za title
        if ($sufix.length) { $sufix = ($sufix.substring(0, 1) == "," ? "" : " ") + $sufix.trim(); }

        $title = $perex + $title + $sufix;
        $title = $title.trim();

        if (sortAppend && sortAppend.length) {
            $title += sortAppend;
        }

        if ($title && $title.length) {
            $title = $title[0].toUpperCase() + $title.slice(1).toLowerCase() + $sWeb;
            $("title").html($title);
            $("meta[name=title]").attr("content", $title);
        }

        $sufix = "";
        $perex = "";

        ////////////////////////////////////////////
        // meta description
        $.each($seoParam, function (i, item) {
            if (item.sMetaDescriptionType == "replace" && item.sMetaDescription.length) {
                $metaDesc = item.sMetaDescription;
            }
            else if (item.sMetaDescriptionType == "sufix" && item.sMetaDescription.length) {
                // pridat za
                $sufix = $sufix + (item.sMetaDescription.substring(0, 1) == "," ? "" : " ") + item.sMetaDescription;
            }
            else if (item.sMetaDescriptionType == "perex" && item.sMetaDescription.length) {
                // pridat pred
                $perex = $perex + " " + item.sMetaDescription;
            }
        });

        // pred meta desc
        if ($perex.length) { $perex = $perex.trim() + " "; }
        // za meta desc
        if ($sufix.length) { $sufix = ($sufix.substring(0, 1) == "," ? "" : " ") + $sufix.trim(); }

        $metaDesc = $perex + $metaDescOrig + $sufix;
        $metaDesc = shortenString($metaDesc, 160);

        if ($metaDesc && $metaDesc.length) {
            //$metaDesc = $metaDesc[0].toUpperCase() + $metaDesc.slice(1).toLowerCase();
            $("meta[name=description]").attr("content", $metaDesc);
        }
    }
    else {
        if ($h1Orig && $h1Orig.length) {
            $("h1:first").html($h1Orig + sortAppend);
        }

        if ($titleOrig && $titleOrig.length) {
            $("title").html($titleOrig + sortAppend);
        }
    }
}

function InnerH1() {
    if ($h1 == 'empty') { $h1 = $("h1:first").html(); }
    if ($title == 'empty') { $title = $(document).attr('title'); }
    // parametry
    var action = 0;

    $("#formFiltersParam input[name=H1Add], #filters-tab input[name=H1Add], #formFiltersParam input[id=SpecParamH1], #filters-tab input[id=SpecParamH1]").each(function () {
        // toto jsou predefinovane h1 u parametru
        if ($(this).attr("name") == "H1Add" && $(this).val()?.toString().trim().length > 0) {
            $("h1:first").html($(this).val()?.toString());
            action = 1;
        }

        if ($(this).attr("id") == "SpecParamH1" && $(this).val()?.toString().trim().length > 0) {
            $("h1:first").html($(this).val()?.toString());
            action = 1;
        }
    });

    // staticke filtry
    if ($countPar == 0 && $("#frmFilter input:checked").length == 1) {
        $countPar = $("#frmFilter input:checked").length;
    }

    if (($countPar == 1 || $countPar == 2) && action == 0) {
        $("h1:first").html($h1 + PrepareParamText());
        $('title').html($title.replace("|", PrepareParamText() + " |"));
        $("meta[name=title]").attr("content", $title.replace("|", PrepareParamText() + " |"));
    }

    if (action == 0 && $countPar != 1 && $countPar != 2 && $("h1").html() != $h1) {
        $("h1:first").html($h1);
        $('title').html($title);
        $("meta[name=title]").attr("content", $title);
    }
}

function GetTitle() {
    var action = 0;
    var res = "";
    var sWeb = gsNameWeb.length > 0 && gsNameWeb != "empty" ? " | " + gsNameWeb : "";

    $("#formFiltersParam input:hidden, #filters-tab input:hidden").each(function () {
        // toto jsou predefinovane h1 u parametru
        if ($(this).attr("name") == "Title" && $(this).val()?.toString().length > 0) {
            res = $(this).val()?.toString();
            action = 1;
        }

        if ($(this).attr("id") == "SpecParamTitle" && $(this).val()?.toString().length > 0) {
            res = $(this).val()?.toString();
            action = 1;
        }
    });

    if (action == 1) {
        return res + sWeb;
    }
    else if (PrepareParamText().length > 0) {
        return $h1 + PrepareParamText() + sWeb;
    }
    else {
        return $title;
    }
}

function preparePageVsHash() {
    if (location.hash.indexOf("#gallery") >= 0) {
        // toto je fotogalerie fancyboxu, neni treba spoustet ajax na katalog
        return;
    }

    $sort = getParmFromHash(location.href.replace('#', '&'), "sort");
    $iop = getParmFromHash(location.href.replace('#', '&'), "iop");
    $vcp = getParmFromHash(location.href.replace('#', '&'), "vcp");
    $filterPrice = getParmFromHash(location.href.replace('#', '&'), "fPrice");

    var href = '';
    if (location.href.indexOf('?search=') == -1) {
        var re1 = /\/p(\d+)\//g;
        href = location.href.replace(re1, "&page=$1&");
    }
    $page = parseInt(getParmFromHash(href, "page") !== "" ? getParmFromHash(href, "page") : "1");
    if ($page == 0) {
        $page = 1;
    }

    loadAjaxContent(false);
}

function getClearUrl3(s) {
    var p = "";
    var l = window.location.pathname;
    var q = window.location.search;
    var hash = "";
    var $pagerUrlPostfix = $urlPostfix;
    $search = getParmFromHash(q, 'search');
    
    if (features.SEOParam && typeof $urlOrig !== "undefined" && $urlOrig.length && !$search.length) {
        $pagerUrlPostfix = "/";
        if ($paramSeo.length || $filterCustomAttr.length || $sort.length || $page > 1 || $pge > 0) {
            l = $urlOrig.replace($urlPostfix, "/") + $urlSeo;
        }
        else {
            l = $urlOrig;
        }

        if ($filterPrice != "") {
            s = "fPrice=" + $filterPrice;
        }
    }
    
    // odstrani z url strankovani
    l = l.replace(pattern, "");
    
    if ($sort) {
        s = s.replace('&page=' + $page, '');
        s = s.replace('page=' + $page, '');
    } 
    else {
        s = s.replace('page=' + $page, '');
    }

    // atributy nastavene v Odkaz / parametry, nemusi byt v url
    if ($filterHiddenAttr != "" && $filterCustomAttr == "") {
        s = s.replace('&fattr='+ $filterHiddenAttr, '');
    }
    else if ($filterHiddenAttr != "" && $filterCustomAttr != "") {
        s = s.replace($filterHiddenAttr, '');
    }

    s = s.replace('&pnext=' + $pnext, '');
    s = s.replace('&pge=' + $pge, '');
    s = s.replace('&cat=' + $cat, '');
    s = s.replace('&pcat=' + $pcat, '');
    // s = s.replace('&tags=' + $tags, '');
    s = s.replace('&item=' + $item, '');
    s = s.replace('&producer=' + $producer, '');
    s = s.replace($eventIds, '');
    s = s.replace('&aa=1', '');
    s = s.replace('&filter=on', '');
    s = s.replace('&sProd=1', '');
    s = s.replace('&series=1', '');
    s = s.replace('&sArt=10', '').replace('&sArt=20', '').replace('&sArt=30', '').replace('&sArt=1', '').replace('&sArt=2', '');

    if ($page == 1 && $pge == 0) {
        //
    }
    else if ($producer > 0 && !features.PersonalUrl) {
        p = "?page=" + $page;
    }
    else if ($nextPageOwner && q.indexOf("search=") == -1) 
    {
        // klasicke strankovani v kategorii
        if ($pge > 0 && ($pagerUrlPostfix == "" || l.lastIndexOf("/") != l.length - 1)) { p = "/p" + $pnext + "-" + $page; }
        else { p = "p" + $pnext + "-" + $page; }
        
        p += $pagerUrlPostfix;
    }
    else if (q.indexOf("search=") > 0) {
        s += (s.indexOf('page=') == -1 ? '&page=' + $page : "");
    }
    else {
        if ($pagerUrlPostfix == "") {
            p = "/p" + $page;
        }
        else {
            p = 'p' + $page;
        }
        p += $pagerUrlPostfix;
    }

    if (typeof $type != "undefined" && $type !== "" && $type !== "pr") {
        // pridavam si tam typ, abych pri nacteni stranky, ne ajax,  vedel co mam strankovat
        s += "&t=" + $type;
    }

    if (s.substring(0, 1) == "&") { s = s.substring(1) };
    if (s.length > 0) { s = "?" + s; }

    if ($pagerUrlPostfix == "" && l.substr(-1) === "/") {
        l = l.slice(0, -1);
    }

    l = l + p + s + hash;

    l = l.replace(/,$/, ''); // odstran carku na konci retezce

    return l;
}

if (IsSafariBrowser()) {
    $paramF = GetParam("par");

    bindForm();
    BindCategoriesFilter();
    BindAttributesFilter();
    BindProducersFilter();
    InitProducerFilter();
    InitAvailabilityFilter();
    BindSeries();
    PrepareHiddenAttr();

    if (location.hash.length > 1 && $search === ''
        && window.location.hash.indexOf('#step=') === -1) {
        preparePageVsHash();
    }

    ProductPreview();
    availability();
    setTimeout(prepareLinks, 300);

    // varianta AJAX catalogu -> dodatecne nacteni
    if ($(".ajax-filter-init").length) {
        RemoveAllFilter(true);
    }

    // zadám si aktuální URL
    history.replaceState("reload", gsNameWeb, window.location.href);
}
else {
    $(document).ready(function () {
        $paramF = GetParam("par");

        bindForm();
        BindCategoriesFilter();
        BindAttributesFilter();
        BindProducersFilter();
        InitProducerFilter();
        InitAvailabilityFilter();
        BindSeries();

        if (location.hash.length > 1 && $search === ''
            && window.location.hash.indexOf('#bonuspage=') === -1
            && window.location.hash.indexOf('#step=') === -1) {
            preparePageVsHash();
        }

        ProductPreview();
        availability();
        prepareLinks();
        PrepareHiddenAttr();

        $filter = GetParam("filter");
        $filterPrice = GetParam("fPrice");
        $filterCustomAttr = GetParam("fattr");
        $filterAvail = GetParam("dostupnost");
        $catsF = GetParam("fCats");

        //Varianta AJAX catalogu -> dodatecne nacteni
        if ($(".ajax-filter-init").length) {
            RemoveAllFilter(true);
        }

        // zadám si aktuální URL
        history.replaceState("reload", gsNameWeb, window.location.href);

        if ($nextPageSelectors.length !== $nextPageItemsSelectors.length) {
            console.log(`Nesouhlasí délka prvků: $nextPageSelectors=${$nextPageSelectors.length} $nextPageItemsSelectors=${$nextPageItemsSelectors.length}`);
        }

        // toto potrebuji ulozit, abych po nacteni predchozi stranky nastavil pozici na ktere jsem byl
        $(window).on("scroll", throttle(function () {
            AddItemToLocalStorage("bonusPage-previos-position", Number($(window).scrollTop().toString()).toString());
        }, 200));
    });
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Osetreni tlacitka zpet po ajaxu. 
window.addEventListener('popstate', function (event) {
    if (event == null && event.state === "reload") {
        // nemam zadnou historii, tak relodnem stranku
        window.location.href = window.location.href;
    }
    else if (event.state) {
        $backFromHistory = true;
        $makeScroll = true;

        var state = history.state;
        var hash = window.location.hash;
        
        if (state && state.length && state.substring(1) != "&") {
            // toto potrebuji, aby fungovala fn getParmFromHash
            state = "&" + state;
        }
        
        $paramF = getParmFromHash(state, "par");
        $sort = getParmFromHash(state, "sort");
        $filter = getParmFromHash(state, "filter");
        $filterPrice = getParmFromHash(state, "fPrice");
        $filterCustomAttr = getParmFromHash(state, "fattr");
        $filterProducer = getParmFromHash(state, sNameParZnacka);
        $vcp = getParmFromHash(state, "vcp");
        $iop = getParmFromHash(state, "iop");
        $page = parseInt(getParmFromHash(state, "page")) || 1;
        $pge = parseInt(getParmFromHash(state, "pge")) || 0;
        $pnext = parseInt(getParmFromHash(state, "pnext")) || 0;
        $tags = getParmFromHash(state, "tags");

        if (getParmFromHash(state, "search") != "") {
            if (state.indexOf('&sCat=1') != -1) { $searchAppend = '&filter=on&sCat=1'; }
            else if (state.indexOf('&sArt=30') != -1) { $searchAppend = '&filter=on&sArt=30'; }
            else if (state.indexOf('&sArt=20') != -1) { $searchAppend = '&filter=on&sArt=20'; }
            else if (state.indexOf('&sArt=10') != -1) { $searchAppend = '&filter=on&sArt=10'; }
            else if (state.indexOf('&sArt=1') != -1) { $searchAppend = '&filter=on&sArt=1'; }
            else if (state.indexOf('&sArt=2') != -1) { $searchAppend = '&filter=on&sArt=2'; }
            else if (state.indexOf('&sFor=1') != -1) { $searchAppend = '&filter=on&sFor=1'; }
            else if (state.indexOf('&sFile=1') != -1) { $searchAppend = '&filter=on&sFile=1'; }
            else if (state.indexOf('&sSeries=1') != -1) { $searchAppend = '&filter=on&sSeries=1'; }
            else { $searchAppend = '&filter=on&sProd=1'; }
            if (state.indexOf('&spcat=') !== -1) { $searchAppend += '&spcat=' + getParmFromUrlHash(state, "spcat"); }
            
        }

        loadAjaxContent(false);
    }
}, false);


function ProductPreview() {
    $('.product-preview').on('click', function (e) {
        e.preventDefault();
        var self = $(this);
        var id = self.data('i');
        var name = self.data('n');
        var moduleId = self.data('m');

        EshopService("QuickViewLoad", { commodityId: id, commodityName: name, moduleId: moduleId }, true, function (result: InfoValueResult) {
            if (result.Value.length > 0) {
                $.fancybox.open(result.Value, {
                    defaultType: 'inline',
                    btnTpl:
                    {
                        close: '<a title="' + GetTextDynamic("fancybox_button_close") + '" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                        arrowRight: '<a title="' + GetTextDynamic("fancybox_button_next") + '" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                        arrowLeft: '<a title="' + GetTextDynamic("fancybox_button_prev") + '" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
                    },
                    hideScrollbar: true
                    //autoCenter: false
                });
            }
        });
    });
}

function ClickHid(o) {
    var oP = $(o).closest("div");
    //var oP = ($(o).parent("div").first() as HTMLDivElement);

    if (oP.hasClass("open")) {
        oP.removeClass("open").addClass("close");
    }
    else {
        oP.removeClass("close").addClass("open");

        if (oP.find('.with-slider .jqrangeslider').length) {
            // toto je input kde se zadaji hodnoty, nastaveni modulu (paramSliderEditInput)
            oP.find('.with-slider .jqrangeslider').editRangeSlider('resize');
        }

        if (oP.find('.with-slider .slider').length) {
            // toto je slider bez moznosti zadat hodnoty, nastaveni modulu (paramSliderEditInput)
            oP.find('.with-slider .slider').rangeSlider('resize');
        }

        if (oP.hasClass("priceSliderBox")) {
            if (typeof SetSliderPrices === 'function') { SetSliderPrices(); }
        }
    }
    fn_GTM_sendFiltersPushState($(o));
}

function ParamSliderRemoveFiletr(slider) {
    var sMin = 'hdnsl_' + slider.replace(/-/g, "") + 'min';
    var sMax = 'hdnsl_' + slider.replace(/-/g, "") + 'max';

    // Zjistime default hodnoty at to muzeme naresetovat.
    var minVal = $("input[name='" + sMin + "']").val();
    var maxVal = $("input[name='" + sMax + "']").val();

    var defaultMinValue = slider + "|" + minVal;
    var defaultMaxValue = slider + "|" + maxVal;

    // Nastavime hodnoty inputu
    $("#minsl_" + slider.replace(/-/g, "")).val(defaultMinValue).removeClass("paramUsed").prop('checked', false);
    $("#maxsl_" + slider.replace(/-/g, "")).val(defaultMaxValue).removeClass("paramUsed").prop('checked', false);

    try { $("#sl_" + slider.replace("-", "")).editRangeSlider("destroy"); } catch (ex) { ; }
    try { $("#sl_" + slider.replace("-", "")).rangeSlider("destroy"); } catch (ex) { ; }

    PrepareParam();

    if (features.SEOParam) { PrepareSeoUrl(); }

    loadAjaxContent(false);
}

function InitAfterAjaxCatalogForSiteScript() {
}

function RemoveAllFilter(init) {
    if (init) {
        if (GetParam("par") == "") {
            //temporary commented
            //ResetFilterVariables();
        }

        loadAjaxContent(true);
    } else {
        ResetFilterVariables();
        bindForm();
        loadAjaxContent(false);
    }

    return false;
}

function ResetFilterVariables() {
    $page = 1;
    $pge = 0;
    $pnext = 0;
    $search = '';
    $tags = '';
    $cat = 0;
    $item = 0;
    $producer = 0;
    $pcat = 0;
    $iop = '';
    $vcp = '';
    $b2bFilter = '';
    $paramF = '';
    $urlSeo = '';
    $paramLastF = '';
    $filter = '';
    $filterContractor = '';
    $filterCustomAttr = '';
    $isExistAttrNeg = false;
    $filterProducer = '';
    $filterOthers = '';
    $filterPrice = '';
    $filterAvail = '';
    $sort = '';
    $wsv = 0;
    $eventIds = '';
    if (features.SEOParam && $paramSeo != null && $paramSeo.length) { 
        $paramSeo.length = 0;
    }
}

function openFilters() {
    if ($("#filters-tab li:first").length) {
        $("#filters-tab li:first").trigger("click");
    }
}

function initAjaxDater() {
    $('.dater-fb-info').unbind('click').click(function (e) {
        e.preventDefault();
        var attr = $(this).attr('data-id').replace('DaterDelivery-', '');
        EshopService("DaterInfo", { stockRuleId: attr.split('-')[0], site: attr.split('-')[1], lang: attr.split('-')[2], codeLang: attr.split('-')[3], isOnStock: attr.split("-")[4] }, true, function (result: InfoValueResult) {
            if (result.Value.length > 0) {
                var resValue = "<div id=\"DaterDeliveryText\">" + result.Value + "</div>";
                $.fancybox.open(resValue, { defaultType: "inline" });
            }
        });
    });
}

//nacteni poradny - ajaxove
function AdviceInCatalog() {
    if ($('.sort-advice').hasClass('active')) return;

    var t = GetTextDynamic("sort_title_type_advice");
    if (t != '' && t != '#' && $('#formSort h2').length > 0) { $('#formSort h2').html(t); }

    var sSerialize = "&type=184&cat=" + $cat + (lang.length > 0 ? "&lang=" + lang : "");
    var $target = $('.content-19');

    $('a[class^="sort-"][class*="active"]').click(function () {
        $('#hiddensort').val($(this).data("sort"));
        $('#formSort').submit();
    });
    $('a[class^="sort-"][class*="active"]').removeClass('active');
    $('.sort-advice').addClass('active');

    $.ajax({
        type: "GET",
        cache: false,
        url: "/ajax/layerContent.aspx",
        data: sSerialize,
        error: function (data) {
            preloader(false);
        },
        beforeSend: function () {
            preloader(true);
        },
        success: function (data) {
            $target.html(data);
            preloader(false);
        }
    });
}

function fn_GTM_bindFilter() {
    if ($("#xformFiltersParam input[type=hidden], #xformFiltersParam select").length > 0 && typeof dataLayer !== 'undefined') {
        $("#xformFiltersParam input[type=hidden], #xformFiltersParam select, #xformFiltersParam .ui-rangeSlider").on("change valuesChanged", function () { fn_GTM_sendFiltersPushState($(this)) })
        $("#xformFiltersParam input[type=hidden]")
            .on("change", function () { fn_GTM_sendFiltersPushState($(this)) })
    }
}

// pošle push state pro filtr do google GTM
function fn_GTM_sendFiltersPushState(o) {
    if (typeof dataLayer !== 'undefined') {
        var fnm = o.parentsUntil(".fltrSection").parent().find("h3").text().trim();
        if (fnm == "") { fnm = o.text().trim(); }

        dataLayer.push({
            'event': 'GAevent', 'eventCategory': 'Filters', 'eventAction': fnm, 'eventLabel': location.href, 'eventNoninteraction': true
        })
    }
}

function InitParamSliderEasy(sliderHtmlId, arr, cv, filtervalue, baseName, disabled) {
    var minV = 0;
    var maxV = arr[arr.length - 1];
    var currentValue = arr.indexOf(cv);
    var $stopSlider = true;
    $('#min' + sliderHtmlId).prop('checked', (cv !== ''));
    $('#' + sliderHtmlId).slider({
        step: 0.1,
        min: minV,
        max: maxV,
        value: filtervalue,
        slide: function (event, ui) {
            var v = (ui.value === 0 ? '' : ui.value + '');
            if (arr.indexOf(v) === -1) { console.log('off- ' + ui.value); return false; }
        },
        create: function (event, ui) {
            $("#" + sliderHtmlId + " .dot span, #" + sliderHtmlId + " .last span").each(function () {
                var s = (-1) * $(this).width() / 2;
                $(this).css("margin-right", s)
            });
        },
        change: function (event, ui) {
            var v = (ui.value === 0 ? '' : ui.value + '');
            if (arr.indexOf(v) === -1) { console.log('off- ' + ui.value); return false; }
            $('#min' + sliderHtmlId).prop('checked', (v !== ''));
            if ((currentValue !== v) && !$stopSlider) {
                $('#min' + sliderHtmlId).val(baseName + '|' + v).data("value", v);
                $('#max' + sliderHtmlId).val(baseName + '|' + v).data("value", v);
                $paramLastF = getLastParamSlider(WordToUrl(baseName));

                PrepareParam();

                if (features.SEOParam) { PrepareSeoUrl(); }

                loadAjaxContent(false);
            }
        }
    });

    if (disabled)
        $('#' + sliderHtmlId).slider('disable');

    $stopSlider = false;
}

function FloatingmenuheightGet() {
    if ($(".flow-menu, .floating-menu-wrap").length) {
        // vyska plovouciho menu
        $floatingmenuheight = $(".flow-menu, .floating-menu-wrap").height();
    }
}

function PrepareSeoUrl() {
    $urlSeo = "";
    $paramSeo.length = 0;
    $paramF = "";
    $filterCustomAttr = "";

    // hodnoty parametru pro url
    $("#formFiltersParam input:checkbox:checked:not(:disabled), [class^=filters-tab-param] input:checkbox:checked:not(:disabled)").each(function () {
        if ($(this).data("type") == "seourl" && $(this).data("catparam") != "1") {
            $paramSeo.push({ name: $(this).data("name"), value: $(this).data("value") });
        }

        if ($paramF.length > 0) { $paramF += "," }
        $paramF += WordToUrl($(this).val()?.toString().trim());
    });

    // vytvoreni url z parametru
    if ($paramSeo.length) {
        var $par = $paramSeo.filter(x => x.name).map(x => x.name);
        $par = $.grep($par, function (item, index) { return index === $.inArray(item, $par); });
        $par.forEach(function (item) {
            $urlSeo += ($urlSeo.length ? "/" : "") + item + "_" + $paramSeo.filter(x => x.name === item).map(x => x.value).join("+");
        });
    }

    // atributy do url
    $("#formFiltersCustomAttr input:checkbox:checked").each(function () {
        if ($(this).data("url").length && !$(this).is(":disabled")) {
            $urlSeo += ($urlSeo.length ? "/" : "") + $(this).data("url");
        }

        if ($filterCustomAttr.length > 0) {
            $filterCustomAttr += ","
        }
        $filterCustomAttr += $(this).val();
    });

    // razeni
    var $sortSeo = $sort ?? SortValGet();
    if ($sortSeo.length) {
        var sortUrl = GetTextDynamic("sort_type_" + $sortSeo + "_url");

        if (sortUrl.length) {
            $urlSeo += ($urlSeo.length ? "/" : "") + sortUrl;
        }
    }

    // strankovani
    if ($page > 1 && $urlSeo.length && $urlSeo.substring($urlSeo.length - 1) != "/") {
        $urlSeo += "/";
    }
}

function SortValGet() {
    var $ret = "";

    if ($("select[name='sort']").length > 0) {
        $ret = $("select[name='sort'] :selected").val()?.toString();
    }
    else if ($(".form-sort-link").length && $(".form-sort-link .active[data-sort]").data("sort") != null) {
        $ret = $(".form-sort-link .active[data-sort]").data("sort");
    }
    else if ($("#hiddensort").length) {
        $ret = $("#hiddensort").val()?.toString();
    }
    return $ret;
}